import { render, staticRenderFns } from "./FlashSale.vue?vue&type=template&id=1b6ba26b"
import script from "./FlashSale.vue?vue&type=script&lang=js"
export * from "./FlashSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports